import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthFacade } from './core/store/auth/auth.facade';
import { IconsService } from './shared/icons/icons.service';
import { objIconsMock } from './shared/icons/mockCustomIcons';
import { WINDOW } from './shared/services/window-providers';
import { SystemFacade } from './shared/system/system.facade';

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
  styles: [],
})
export class AppComponent implements OnInit {
  constructor(
    private authFacade: AuthFacade,
    private router: Router,
    @Inject(WINDOW) private window: Window,
    private dialog: MatDialog,
    private iconsService: IconsService, // register custom icons,
    private systemFacade: SystemFacade
  ) {}

  verifyTest(isRouteTest: boolean, event: any) {
    const isFirstEvent = event?.id === 1;

    if (isFirstEvent) {
      if (isRouteTest) {
        return;
      }
      return true;
    } else {
      return;
    }
  }

  ngOnInit() {
    this.mountAllSVGIcons();
    // this.systemFacade.getTenantConfig();
    //
    // this.checkSubdomain();
    // this.systemFacade.tenantConfig$.subscribe((config) => {
    //   const isProd = environment.production;
    //   const cityName = config?.cidade;
    //   // environment.apiUrlPostgrest = `${environment.apiGatewayUrl}rest-db-${cityName}/`;
    //   environment.apiUrlPostgrest = `https://${cityName}.${environment.postgRestUrl}`;
    //   // environment.apiUrlPGTiles = `https://${cityName}.${environment.pgtilesUrl}`;
    //   environment.apiUrlPGTiles = isProd
    //     ? `https://${cityName}.${environment.pgtilesUrl}`
    //     : // : `https://gateway.geo360.com.br/api-tiles-${cityName}/`;
    //       `https://${cityName}.${environment.pgtilesUrl}`;
    // });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        const isIcad = event.url.includes('icad');
        const isSimples = event.url.includes('simples');
        const isRouteTest = event.url.includes('?teste=true');

        if (isSimples) {
          if (this.checkCity('ararangua')) {
            /* if (this.verifyTest(!!isRouteTest, event)) {
              this.router.navigate(['manutencao']);
            } */
          }
        }

        if (isIcad) {
          if (this.checkCity('criciuma')) {
            // this.router.navigate(['manutencao']);
            /* if (this.verifyTest(!!isRouteTest, event)) {
              this.router.navigate(['manutencao']);
            } */
          }
        }

        if (isIcad) {
          if (this.checkCity('brusque')) {
            // this.router.navigate(['manutencao']);
            /* if (this.verifyTest(!!isRouteTest, event)) {
              this.router.navigate(['manutencao']);
            } */
          }
        }
      });
  }

  async mountAllSVGIcons() {
    objIconsMock.forEach((item) => {
      if (item.folderName !== 'mdi') {
        item.icons.map((icon) => {
          const iconName = `${item.folderName}/${icon}`;
          const iconPath = `../assets/icons/svg_symbols/${item.folderName}/${icon}.svg`;
          this.iconsService.registerCustomIcon(iconPath, iconName);
        });
      }
    });
  }

  checkCity(cityToCheck: string) {
    if (environment.production) {
      let site = window.location.href;
      if (site.includes('www.')) {
        site = site.replace('www.', '');
      }
      if (site.includes('.com')) {
        site = site.replace('.com', '');
      }
      if (site.includes('.dev.br')) {
        site = site.replace('.dev.br', '');
      }
      if (site.includes('.dev')) {
        site = site.replace('.dev', '');
      }
      if (site.includes('.com.br')) {
        site = site.replace('.com.br', '');
      }

      const subdomain = site.split('.')[0];
      let city = '';

      if (subdomain.length == 2) {
        // Checa para novo padrão de URLs com unico nivel de dominio, por exemplo: http://portovelho-portal-geo360.portovelho.ro.gov.br

        city = subdomain.split('-')[0].split('//').pop() as string;
      } else {
        // Mantem retrocompatibilidade com padrão de URLs com multiplos niveis de dominio, por exemplo: http://portovelho.portal.geo360.portovelho.ro.gov.br

        city = subdomain.split('//').pop() as string;
      }
      return city === cityToCheck;
    }
  }
}
